<div class="w-full min-w-0 py-8 px-3 sm:px-4 md:py-14 md:px-6 2xl:px-20 2xl:container 2xl:mx-auto">
  <div class="flex justify-start item-start space-y-2 flex-col">
    <h1
      class="break-all text-2xl dark:text-white sm:text-3xl lg:text-4xl font-semibold leading-7 lg:leading-9 text-gray-800"
    >
      Order Id #{{ ordesDeails?._id }}
    </h1>
    <p
      class="text-base dark:text-gray-300 font-medium leading-6 text-gray-600 sm:ml-5"
    >
      {{ ordesDeails?.createdAt | date: "dd MMM yyyy" }}
    </p>
  </div>
  <div
    class="mt-10 flex flex-col xl:flex-row jusitfy-center items-stretch w-full xl:space-x-8 space-y-4 md:space-y-6 xl:space-y-0"
  >
    <div
      class="flex flex-col justify-start items-start w-full space-y-4 md:space-y-6 xl:space-y-8"
    >
      <div
        class="flex flex-col justify-start items-start dark:bg-gray-800 bg-white px-4 py-4 md:py-6 md:p-6 xl:p-8 w-full"
      >
        <p
          class="text-lg md:text-xl dark:text-white font-semibold leading-6 xl:leading-5 text-gray-800"
        >
          Customer’s Cart
        </p>
        <div class="max-w-full overflow-x-auto w-full mt-4">
          <table
            class="min-w-[36rem] w-full border-2 border-white rounded-lg divide-y divide-gray-200"
          >
            <thead class="btncolor text-white">
              <tr>
                <th class="px-4 py-2 text-left text-sm md:text-base">
                  Product
                </th>
                <th class="px-4 py-2 text-left text-sm md:text-base">
                  Product Link
                </th>
                <th class="px-4 py-2 text-left text-sm md:text-base">Price</th>
                <th class="px-4 py-2 text-left text-sm md:text-base">
                  Quantity
                </th>
                <th class="px-4 py-2 text-left text-sm md:text-base">Total</th>
              </tr>
            </thead>
            <tbody
              class="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700"
            >
              <tr *ngFor="let item of ordesDeails?.items">
                <!-- Product Image -->
                <td class="px-4 py-2 w-24">
                  <img
                    class="w-20 h-20 object-cover rounded-md"
                    [src]="orderListDetailsImageUrl + item?.displayImage"
                    alt="{{ item?.name }}"
                  />
                </td>

                <!-- Name -->
                <td
                  class="px-4 py-2 text-sm md:text-base text-gray-800 dark:text-white"
                >
                  <a
                    *ngIf="item?.product_id?._id; else productName"
                    [routerLink]="['/product-details', item.product_id._id]"
                    class="text-blue-700 underline hover:text-blue-900 dark:text-blue-300 dark:hover:text-blue-200"
                  >
                    {{ item?.name }}
                  </a>
                  <ng-template #productName>{{ item?.name }}</ng-template>
                  <!-- <div class="text-gray-500 text-xs md:text-sm" *ngIf="ordesDeails.length > 0" >
            Size: {{ item?.product_id?.variants?.size }}, Color: {{ item?.product_id?.variants?.color }}
          </div> -->
                </td>

                <!-- Price -->
                <td
                  class="px-4 py-2 text-sm md:text-base text-gray-800 dark:text-white"
                >
                  Rs. {{ item?.price }}
                </td>

                <!-- Quantity -->
                <td
                  class="px-4 py-2 text-sm md:text-base text-gray-800 dark:text-white"
                >
                  {{ item?.quantity }}
                </td>

                <!-- Total -->
                <td
                  class="px-4 py-2 text-sm md:text-base font-bold text-purple-700 dark:text-purple-400"
                >
                  Rs. {{ item?.price * item?.quantity }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        class="flex flex-col items-stretch w-full space-y-4 md:flex-row md:space-y-0 md:space-x-6 xl:space-x-8"
      >
        <div
          class="flex flex-col px-4 py-6 md:p-6 xl:p-8 w-full bg-gray-50 dark:bg-gray-800 space-y-6"
        >
          <h3
            class="text-xl dark:text-white font-semibold leading-5 text-gray-800"
          >
            Summary
          </h3>
          <div
            class="flex justify-center items-center w-full space-y-4 flex-col border-gray-200 border-b pb-4"
          >
            <div class="flex justify-between w-full">
              <p class="text-base dark:text-white leading-4 text-gray-800">
                Subtotal
              </p>
              <p
                class="text-base dark:text-gray-300 leading-4 text-gray-600"
              ></p>
              <p class="text-base dark:text-gray-300 leading-4 text-gray-600">
                Rs. {{ getTotalAmount() }}
              </p>
            </div>
            <div class="flex justify-between items-center w-full">
              <p class="text-base dark:text-white leading-4 text-gray-800">
                Discount
                <span
                  class="bg-gray-200 p-1 text-xs font-medium dark:bg-white dark:text-gray-800 leading-3 text-gray-800"
                  >{{ ordesDeails?.payment_gateway }}</span
                >
              </p>
              <p
                class="text-base dark:text-gray-300 leading-4 text-gray-600"
                *ngIf="ordesDeails?.payment_gateway === 'Prepaid'"
              >
                Rs. 40 (Off)
              </p>
              <p
                class="text-base dark:text-gray-300 leading-4 text-gray-600"
                *ngIf="ordesDeails?.payment_gateway === 'COD'"
              >
                Rs. 0
              </p>
            </div>
            <div class="flex justify-between items-center w-full">
              <p class="text-base dark:text-white leading-4 text-gray-800">
                coupon_amount
                <!-- <span
                  class="bg-gray-200 p-1 text-xs font-medium dark:bg-white dark:text-gray-800 leading-3 text-gray-800"
                  >(-)</span -->
                <!-- > -->
              </p>
              <p class="text-base dark:text-gray-300 leading-4 text-gray-600">
                Rs. {{ ordesDeails?.coupon_amount }}
              </p>
            </div>
            <div class="flex justify-between items-center w-full">
              <p class="text-base dark:text-white leading-4 text-gray-800">
                Shipping Charge
              </p>
              <p class="text-base dark:text-gray-300 leading-4 text-gray-600">
                Rs.
                {{
                  ordesDeails?.shipping_charge * ordesDeails?.items?.length
                }}
                Free
              </p>
            </div>
          </div>
          <div class="flex justify-between items-center w-full">
            <p
              class="text-base dark:text-white font-semibold leading-4 text-gray-800"
            >
              Total
            </p>
            <p
              class="text-base dark:text-gray-300 font-semibold leading-4 text-gray-600"
            >
              Rs. {{ ordesDeails?.total_amount }}
            </p>
          </div>
        </div>
        <div
          class="flex flex-col justify-center px-4 py-6 md:p-6 xl:p-8 w-full bg-gray-50 dark:bg-gray-800 space-y-6"
        >
          <h3
            class="text-xl dark:text-white font-semibold leading-5 text-gray-800"
          >
            More actions
          </h3>
          <div class="flex justify-between items-start w-full">
            <div class="flex justify-center items-center space-x-4">
              <div class="w-8 h-8">
                <img
                  class="w-full h-full"
                  alt="logo"
                  src="https://i.ibb.co/L8KSdNQ/image-3.png"
                />
              </div>
              <div class="flex flex-col justify-start items-center">
                <div>
                  Download invoice<br /><span class="font-normal"></span>
                </div>
              </div>
            </div>
            <p
              class="text-lg font-semibold leading-6 dark:text-white text-gray-800"
            >
              Rs. {{ ordesDeails?.total_amount }}
            </p>
          </div>
          <div class="w-full flex justify-center items-center">
            <button
              (click)="generateInvoice(ordesDeails?._id)"
              class="hover:bg-black dark:bg-white dark:text-gray-800 dark:hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800 py-5 w-full bg-gray-800 text-base font-medium leading-4 text-white"
            >
              Download Now
            </button>
            <!-- <div  (click)="generateInvoice(ordesDeails?._id)">Download</div> -->
          </div>
        </div>
      </div>
    </div>
    <div
      class="bg-gray-50 dark:bg-gray-800 w-full xl:w-96 flex justify-between items-center md:items-start px-4 py-6 md:p-6 xl:p-8 flex-col"
    >
      <h3 class="text-xl dark:text-white font-semibold leading-5 text-gray-800">
        Customer
      </h3>
      <div
        class="flex flex-col md:flex-row xl:flex-col justify-start items-stretch h-full w-full md:space-x-6 lg:space-x-8 xl:space-x-0"
      >
        <div class="flex flex-col justify-start items-start flex-shrink-0">
          <div
            class="flex justify-center w-full md:justify-start items-center space-x-4 py-8 border-b border-gray-200"
          >
            <!-- <img
              class="h-20 w-20 rounded-lg"
              [src]="
                ordesDeails?.address_id?.user_id?.profileImage
                  ? orderListDetailsImageUrl +
                    ordesDeails?.address_id?.user_id?.profileImage
                  : 'https://i.ibb.co/5TSg7f6/Rectangle-18.png'
              "
              alt="profileImage"
            /> -->
            <svg
              viewBox="0 0 20 20"
              version="1.1"
              class="w-6 h-6"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              fill="#000000"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <title>profile_round [#434242]</title>
                <desc>Created with Sketch.</desc>
                <defs></defs>
                <g
                  id="Page-1"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g
                    id="Dribbble-Light-Preview"
                    transform="translate(-380.000000, -2119.000000)"
                    fill="#000000"
                  >
                    <g id="icons" transform="translate(56.000000, 160.000000)">
                      <path
                        d="M338.083123,1964.99998 C338.083123,1962.79398 336.251842,1960.99998 334,1960.99998 C331.748158,1960.99998 329.916877,1962.79398 329.916877,1964.99998 C329.916877,1967.20599 331.748158,1968.99999 334,1968.99999 C336.251842,1968.99999 338.083123,1967.20599 338.083123,1964.99998 M341.945758,1979 L340.124685,1979 C339.561214,1979 339.103904,1978.552 339.103904,1978 C339.103904,1977.448 339.561214,1977 340.124685,1977 L340.5626,1977 C341.26898,1977 341.790599,1976.303 341.523154,1975.662 C340.286989,1972.69799 337.383888,1970.99999 334,1970.99999 C330.616112,1970.99999 327.713011,1972.69799 326.476846,1975.662 C326.209401,1976.303 326.73102,1977 327.4374,1977 L327.875315,1977 C328.438786,1977 328.896096,1977.448 328.896096,1978 C328.896096,1978.552 328.438786,1979 327.875315,1979 L326.054242,1979 C324.778266,1979 323.773818,1977.857 324.044325,1976.636 C324.787453,1973.27699 327.107688,1970.79799 330.163906,1969.67299 C328.769519,1968.57399 327.875315,1966.88999 327.875315,1964.99998 C327.875315,1961.44898 331.023403,1958.61898 334.733941,1959.04198 C337.422678,1959.34798 339.650022,1961.44698 340.05323,1964.06998 C340.400296,1966.33099 339.456073,1968.39599 337.836094,1969.67299 C340.892312,1970.79799 343.212547,1973.27699 343.955675,1976.636 C344.226182,1977.857 343.221734,1979 341.945758,1979 M337.062342,1978 C337.062342,1978.552 336.605033,1979 336.041562,1979 L331.958438,1979 C331.394967,1979 330.937658,1978.552 330.937658,1978 C330.937658,1977.448 331.394967,1977 331.958438,1977 L336.041562,1977 C336.605033,1977 337.062342,1977.448 337.062342,1978"
                        id="profile_round-[#434242]"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>

            <div class="flex justify-start items-start flex-col space-y-2">
              <p
                class="text-base dark:text-white font-semibold leading-4 text-left text-gray-800"
              >
                {{ ordesDeails?.address_id?.delivery_name }}
              </p>
              <p class="text-sm dark:text-gray-300 leading-5 text-gray-600">
                {{ ordesDeails?.address_id?.delivery_mobile }}
              </p>
            </div>
          </div>

          <div
            class="flex justify-center text-gray-800 dark:text-white md:justify-start items-center space-x-4 py-4 border-b border-gray-200 w-full"
          >
            <svg
              viewBox="0 0 24 24"
              class="w-5 h-5"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <path
                  d="M4 9.00005L10.2 13.65C11.2667 14.45 12.7333 14.45 13.8 13.65L20 9"
                  stroke="#363636"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M3 9.17681C3 8.45047 3.39378 7.78123 4.02871 7.42849L11.0287 3.5396C11.6328 3.20402 12.3672 3.20402 12.9713 3.5396L19.9713 7.42849C20.6062 7.78123 21 8.45047 21 9.17681V17C21 18.1046 20.1046 19 19 19H5C3.89543 19 3 18.1046 3 17V9.17681Z"
                  stroke="#363636"
                  stroke-width="2"
                  stroke-linecap="round"
                ></path>
              </g>
            </svg>
            <p class="cursor-pointer text-sm leading-3">
              {{ ordesDeails?.address_id?.user_id?.email }}
            </p>
          </div>
        </div>
        <div
          class="flex justify-between xl:h-full items-stretch w-full flex-col mt-6 md:mt-0"
        >
          <div
            class="flex justify-center md:justify-start xl:flex-col flex-col md:space-x-6 lg:space-x-8 xl:space-x-0 space-y-4 xl:space-y-12 md:space-y-0 md:flex-row items-center md:items-start"
          >
            <div
              class="flex justify-center md:justify-start items-center md:items-start flex-col space-y-4 xl:mt-8"
            >
              <p
                class="text-base dark:text-white font-semibold leading-4 text-center md:text-left text-gray-800"
              >
                Shipping Address
              </p>
              <p
                class="w-full max-w-xs break-words dark:text-gray-300 xl:max-w-48 text-center md:text-left text-sm leading-5 text-gray-600"
              >
                {{ ordesDeails?.address_id?.delivery_address }},
                {{ ordesDeails?.address_id?.delivery_pincode }},{{
                  ordesDeails?.address_id?.delivery_city
                }},{{ ordesDeails?.address_id?.delivery_state }},{{
                  ordesDeails?.address_id?.delivery_country
                }}
              </p>
            </div>
          </div>
          <div
            class="flex w-full justify-center items-center md:justify-start md:items-start"
          >
            <button
              class="btncolor mt-6 md:mt-0 dark:border-white dark:hover:bg-gray-900 dark:bg-transparent dark:text-white py-5 hover:bg-gray-200 font-medium w-full text-base font-medium leading-4 text-white"
            >
              Rate & Review Product
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
